import DataStore from '@/engine/stores/data-store';

class BudgetSuggestionsDataStore extends DataStore {

}

export default new BudgetSuggestionsDataStore();
